import { render, staticRenderFns } from "./PerformanceOverview.vue?vue&type=template&id=19237b16&scoped=true&"
import script from "./PerformanceOverview.vue?vue&type=script&lang=ts&"
export * from "./PerformanceOverview.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceOverview.vue?vue&type=style&index=0&id=19237b16&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19237b16",
  null
  
)

export default component.exports